import apiClient from "../api/client";
import { MenuCount } from "../types/types";
import {
  MenuItemDetail,
  MenuLookupResponse
} from "../types/menutypes";

export async function getMenuCount(): Promise<MenuCount> {
  const response = await apiClient.get<MenuCount>(
    "/api/Menu/Count"
  );
  return response.data;
}

export const lookupMenuItems = async (
  source: string,
  query: string = "",
  limit: number = 20
): Promise<MenuLookupResponse> => {
  const res = await apiClient.get<MenuLookupResponse>(
    "/api/menu/lookup",
    {
      params: { source, query, limit },
    }
  );

  return res.data;
};

export const getMenuItemDetail = async (
  menuGuid: string,
  storeGuid: string
): Promise<MenuItemDetail> => {
  const res = await apiClient.get<MenuItemDetail>(
    "/api/menu/getitemdetail",
    {
      params: { menuGuid, storeGuid },
    }
  );

  return res.data;
};

export const getMenuOptionGroups = async () => {
  const res = await apiClient.get("/api/MenuOptionGroup");
  return res.data;
};

export const getAllMenuAddOnGroups = async () => {
  const res = await apiClient.get("/api/MenuAddOnGroup");
  return res.data;
};

export const getMenuTraits = async () => {
  const res = await apiClient.get("/api/Menu/GetAllMenuTraits");
  return res.data;
};

export const getRecipesForMenu = async (menuGuid: string) => {
  const res = await apiClient.get(
    "/api/Menu/GetRecipesForMenuId",
    {
      params: { Id: menuGuid },
    }
  );
  return res.data;
};

export const updateRecipe = (payload: any) =>
  apiClient.put("/api/Menu/UpdateRecipe", payload);


export const getPagedMenuItems = async (params: any) => {
  const res = await apiClient.get("/api/Menu/GetPagedMenuItems", { params });
  return res.data;
};

export const updateMenuItem = async (payload: any) => {
  return apiClient.put("/api/Menu/Update", payload);
};

export const getMenuTraitsForMenu = async (guid: string) => {
  const res = await apiClient.get("/api/Menu/GetTraitsForMenuById", {
    params: { Id: guid },
  });
  return res.data;
};

export const getMenuHighlightsById = async (guid: string) => {
  const res = await apiClient.get("/api/Menu/GetMenuHighlightsdById", {
    params: { Id: guid },
  });
  return res.data;
};

export const getKdsLocationsForMenu = async (guid: string) => {
  const res = await apiClient.get("/api/Menu/GetKdsLocationsMenuById", {
    params: { Id: guid },
  });
  return res.data;
};
